import styled from 'styled-components';

const StyledTip = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  max-width: calc((1280px / 3) - 1rem);
`;

const StyledTipImage = styled.img`
  aspect-ratio: 1/1;
  object-fit: cover;
  border-radius: ${(props) => props.theme.radius.md};
`;

export { StyledTip, StyledTipImage };
